export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/projectBusPriority/index.js